/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import {
  useCustomer,
  useEinstein,
  useNavigation,
  useCookie
} from 'msp-integrations'
import PageLayout from '@/components/cms/page-layout'
import { Headline, Button, RegisterForm, MainWrapper } from 'msp-components'
import Advantages from '@/components/atoms/Advantages/Advantages'
import Seo from '@/components/seo'

const Registration = ({ page }: any) => {
  const navigate = useNavigation()
  const customer = useCustomer()
  const { formatMessage } = useIntl()
  const location = useLocation()
  const { getCookieAllowedById } = useCookie()
  const einstein = useEinstein()

  const isSalesforceAllowed = getCookieAllowedById('s291') // CONSENTS['s291'] = 'salesforce'

  // If customer is registered push to account page
  useEffect(() => {
    if (customer.authType != null && customer.isRegistered) {
      navigate('/account')
    }
  }, [customer])

  useEffect(() => {
    einstein.sendViewPage(location.pathname)
  }, [isSalesforceAllowed])

  return (
    <div className='page-main-wrapper page-bg-image'>
      <Seo
        title={
          page.found && page?.meta?.title
            ? page?.meta?.title
            : formatMessage({
                id: 'msp.registration.seo.title',
                defaultMessage: 'Registration'
              })
        }
        description={
          page.found && page?.meta?.description
            ? page?.meta?.description
            : formatMessage({
                id: 'msp.registration.seo.description',
                defaultMessage: 'Register at DARQ'
              })
        }
        keywords={
          page.found && page?.meta?.keywords ? page?.meta?.keywords : ''
        }
        canonicalPath={'/registration'}
      />
      <MainWrapper className='page-grid'>
        <div className='page-col page-left-col'>
          <div className='page-content-wrapper'>
            <Headline className='headline-h2'>
              {formatMessage({
                id: 'msp.registration.title',
                defaultMessage: 'Registration'
              })}
            </Headline>
            <RegisterForm />
          </div>
        </div>
        <div className='page-col page-right-col'>
          <div className='page-content-wrapper text-wrapper moz-fit'>
            <Advantages />
            <Button
              onClick={() => navigate('/login')}
              className={
                'text-10 mr-0 mt-11 w-full border border-white bg-black p-4 lg:w-80'
              }
            >
              {formatMessage({
                id: 'msp.registration.login',
                defaultMessage: 'Do you have an account?'
              })}
            </Button>
          </div>
        </div>
      </MainWrapper>
    </div>
  )
}

const RegistrationWrapper = (props) => {
  return <PageLayout {...Object.assign({ ChildPage: Registration }, props)} />
}

export default RegistrationWrapper
